/**
 * Chart의 Modal
 *   - Tab : Palette / Split / X축 데이터 선택 / Y축 Primary Secondary 선택
 */

export default {
  name: 'BriqueChartModal',
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners"
  props: {
    visible: {
      type: Boolean,
      default: true,
      required: false
    },
    tabStep: {
      type: String,
      default: 'palette',
      required: false
    },
    palettes: {
      type: Array,
      default: function () {
        return [
          {
            name: 'ggplot2',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.GGPLOT2')
          },
          {
            name: 'seaborn',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.SEABORN')
          },
          {
            name: 'simple_white',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.SIMPLE_WHITE')
          },
          {
            name: 'plotly',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.PLOTLY')
          },
          {
            name: 'plotly_dark',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.PLOTLY_DARK')
          },
          {
            name: 'plotly_white',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.PLOTLY_WHITE')
          },
          {
            name: 'presentation',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.PRESENTATION')
          },
          {
            name: 'xgridoff',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.XGRIDOFF')
          },
          {
            name: 'ygridoff',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.YGRIDOFF')
          },
          {
            name: 'gridon',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.GRIDON')
          },
          {
            name: 'default',
            label: this.$t('fdc.CHART_COMPONENT.LABEL.PALETTE.DEFAULT')
          }
        ]
      },
      required: false
    },
    paletteName: {
      type: String,
      default: 'default',
      required: false
    },
    parentChartData: {
      type: Array,
      required: true
    },
    parentChartTitle: {
      type: String,
      required: true
    }
  },
  computed: {
  },
  methods: {
    /**
     * 확인 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     */
    onClickConfirmButton (returnObject) {
      // 아무것도 체크되어 있지 않은 split chart는 제거
      // for (let i = this.data.splits.length - 1; i >= 0; i--) {
      //   let splitChart = this.data.splits[i]
      //   if (splitChart.seriesList.filter(item => item.checked).length === 0) {
      //     this.data.splits.splice(i, 1)
      //   }
      // }

      // let oldData = _.cloneDeep(this.data)

      this.$emit('click-confirm-button-in-modal', returnObject, this.data, this.oldData)

      // setTimeout(() => {
      //   if (returnObject.visible) { // returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
      //     this.data = oldData
      //   }
      // })
    },

    /**
     * 취소 버튼 클릭시 처리
     * @param {Object} returnObject returnObject.visible을 true로 하면 모달창이 닫히지 않는다.
     */
    onClickCancelButton (returnObject) {
      this.data = this.oldData
    },

    /**
     * Split Chart 추가
     */
    addChart () {
      window.splitChartNumbering = window.splitChartNumbering || 0
      window.splitChartNumbering++

      let seriesList = []
      let chart1 = {
        id: 'splitChart_' + window.splitChartNumbering,
        title: this.parentChartTitle + ' - ' + this.$t('fdc.CHART_COMPONENT.LABEL.SPLIT_CHART'),
        seriesList
      }
      this.data.splits.push(chart1)

      for (let s of this.parentChartData) {
        let series = { name: s.name, checked: false }
        seriesList.push(series)
      }
    },

    /**
     * Split Chart 제거
     * @param {Integer} index
     * @param {Object} event
     * @returns
     */
    removeChart (index, event) {
      this.data.splits.splice(index, 1)

      event.preventDefault()
      event.stopPropagation()
      return false
    }
  },
  created () {
    this.data.palette.name = this.paletteName
    this.data.tabStep = this.tabSteps.indexOf(this.tabStep)
  },
  watch: {
    tabStep (strTabStep) {
      this.data.tabStep = this.tabSteps.indexOf(strTabStep)
    },
    visible () {
      if (this.visible === false) return
      // y축 초기 세팅
      let element = this.$parent.$el.children[0]

      setTimeout(() => {
        if (this.data.splits.length === 0) { // 초기에는 1개를 추가해 놓는다.
          this.addChart()
        }

        // X축 선택 초기화
        if (element.briqueChartData.isXAsixDataSelection === false) {
          this.data.xAxisDataSelectionList.splice(2, this.data.xAxisDataSelectionList.length)
          this.data.xAxisDataSelectionValue = ''
        }

        if (this.data.xAxisDataSelectionList.length === 2) {
          if (this.parentChartData.length >= 2) { // 시리즈가 1개일때는 넣지 않는다.
            for (let s of this.parentChartData) {
              let series = { name: s.name, value: s.name }
              this.data.xAxisDataSelectionList.push(series)
            }
          }
        }

        this.parentChartData.map((item, i) => {
          this.data.seriesYAxisNameList[i] = element.briqueChartData.seriesStyles[i]?.yaxis || 'y'
        })

        this.oldData = _.cloneDeep(this.data)
      })
    },
    parentChartData (parentChartData) {
      this.data.splits.splice(0, this.data.splits.length)
      this.data.xAxisDataSelectionList.splice(2, this.data.xAxisDataSelectionList.length)
      this.data.xAxisDataSelectionValue = ''
    },
    parentChartTitle (parentChartTitle) {
      this.data.splits.splice(0, this.data.splits.length)
      this.data.xAxisDataSelectionList.splice(2, this.data.xAxisDataSelectionList.length)
      this.data.xAxisDataSelectionValue = ''
    }
  },
  data () {
    return {
      tabSteps: ['palette', 'split', 'xAxisDataSelection', 'yAxisPrimarySecondarySelection'],

      oldData: {},
      data: { // 화면에서 선택 또는 추가한 데이터
        tabStep: '',
        palette: {
          name: undefined
        },
        splits: [// 데이터는 예시임, 호출하는 곳(차트)의 parentChartData로 다시 내용 채워짐
          // {
          //   id: 'chart1',
          //   title: '스플릿 차트 1',
          //   seriesList: [
          //     { name: 'Series1',
          //       checked: true
          //     }
          //   ]
          // }
        ],

        xAxisDataSelectionList: [// X축 데이터 선택 리스트(차트 모달에서 설정한 데이터임)(1개만 선택되어 있음), Index/Default X축 데이터 + Series들
          {
            name: this.$t('fdc.CHART_COMPONENT.LABEL.DEFAULT_X_DATA'), // Index 또는 'Default X축 데이터' 또는 Series들
            value: 'defaultXAxisData'
            // checked: true
          },
          {
            name: this.$t('fdc.CHART_COMPONENT.LABEL.INDEX'), // Index 또는 'Default X축 데이터' 또는 Series들
            value: 'index'
            // checked: true
          }
        ],
        xAxisDataSelectionValue: '',
        seriesYAxisNameList: []
      } // end-data
    } // end - data return
  } // end-data
}
